import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const GlobalControlSettings = lazy(() => import("@scenes/GlobalControl/scenes/Settings/Settings"));

export const globalControlNRO: NavigationRoutingObject = {
  Component: GlobalControlSettings,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("global-control-group-sidebar-pill-menu-option", "Global Control Group"),
  pageNameForTracking: () => "Global Control Group",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("control-group-description-name", "Exclude a percentage of your audience from receiving messages"),
  icon: "nav-system-global-control-group",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("global-control-group-alt-keyword-1", "treatment group"),
        t("global-control-group-alt-keyword-2", "exclusion settings"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
